<template>
	<div class="mt-8 responsive-note">
    <v-snackbar 
      v-model="toaster.visible"
      :timeout="3000"
      :color="toaster.color"
      top
    >
      {{ toaster.message }}
    </v-snackbar>
		<v-card width="1219" class="d-flex pa-5 mb-8">
      <div class="d-flex flex-row justify-space-between">
        <span class="d-flex flex-row align-center b-4 px-2 responsiveFieldUrl mr-5 h-48">
          <input
            v-model="search_name"
            type="text"
            placeholder="Nome"
            class="d-flex urlresponsive"
          >
          <img class="pr-1" style="width:25px; height: 20px" src="../../../../static/images/message.svg">
        </span>
        <span class="d-flex flex-row align-center b-4 px-2 responsiveFieldUrl mr-5 h-48">
          <input
            v-model="search_url"
            type="text"
            placeholder="Url encurtada"
            class="d-flex urlresponsive"
          >
          <img class="pr-1" style="width:25px; height: 20px" src="../../../../static/images/custom_grey.svg">
        </span>
        <date-picker
          v-model="date"
          placeholder="Data"
          class="b-4 mr-5 h-48 d-flex responsiveField align-center pl-2"
          input-class="datePickerBorder"
          format="DD/MM/YYYY"
        />  
      </div>
			<div class="button-wrapper d-flex justify-space-between">
				<v-btn
					@click="fecthLogs"
          :style="disabled ? 'background: var(--grey-day-030)' : 'background: var(--red)'"
          :disabled="disabled"
          outlined
          height="48"
          class="d-flex align-center mr-5"
          :class="disabled ? 'b-4' : 'b-red'"
          width="120"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--white)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text d-flex align-center justify-space-around"
						>
						<img class="pr-2" src="../../../../static/images/search.svg">
						<span style="color: var(--white)">Buscar</span>
					</div>
				</v-btn>
				<v-btn
					@click="clearForm"
          style="background: var(--white); color: var(--dark-grey)"
          outlined
          height="48"
          class="d-flex align-center b-clear"
          width="120"
				>
					<clip-loader
						v-if="loadingClear"
						:loading="loadingClear"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loadingClear"
						class="button-wrapper--text d-flex align-center"
						>
						<img class="pr-2" src="../../../../static/images/load.svg">
						Limpar
					</div>
				</v-btn>
			</div>
		</v-card>

    <h4 style="fontSize: 20px" class="mt-12">Agendamentos</h4>
			<v-expansion-panels class="mt-5 response-note --h" width="1219" height="62">
				<v-expansion-panel v-for="(item, index) in logs" :key="index" class="mt-2 d-flex  flex-column rounded-lg" height="59" id="expansion-item">
					<v-expansion-panel-header class="d-flex align-center" style="padding: 10px 2px; position: initial;">
						<span class="rounded borderLeft" style=""></span> 
						<span :ref="index" class="ml-10 mr-9 font-weight-black widthResponsive breakString">{{item.name}}</span>
            <button
              @click="copyLink(index)"
              style="border: 2px solid var(--grey-day-020); height:40px; width: 20px"
              class="b-4 mr-8 d-flex justify-center align-center"
            >
              <img src="../../../../static/images/square.svg"/>
            </button>
						<span class="font-weight-black mr-3">Data do disparo</span><span class="">{{formatDate(item.createdAt)}}</span>
						<span class="font-weight-black">Horário</span><span class=""> {{formatHour(item.createdAt)}}</span>
            <button
							style="border: 2px solid var(--grey-day-020); height:40px; width: 20px !important"
							class="b-4 mr-6 d-flex justify-center align-center"
							@click="setEditPush(index)"
						>
							<img src="../../../../static/images/edit.svg"/>
						</button>
					</v-expansion-panel-header>
					<v-expansion-panel-content class="ml-5 responsive-note">
            <span class="font-weight-black">Url curta</span>
            <div class="mb-7">{{item.shortUrl}}</div>
						<div
              v-for="(url, index) in item.urls"
              :key="index"
              class="d-flex flex-column"
            >
              <span class="font-weight-black">Link {{index + 1}}</span>
              <div class="d-flex justify-space-between align-center" style="width: 600px">
                <span class="mr-5" :ref="'link'+index" style="width: 400px; word-break: break-word;">{{url.referenceUrl}}</span>
                <button
                  v-clipboard:copy="url.referenceUrl"
                  v-clipboard:success="copySucess"
                  style="border: 2px solid var(--grey-day-020); height:40px; width: 40px"
                  class="b-4 mr-6 d-flex justify-center align-center"
                >
                  <img src="../../../../static/images/square.svg"/>
                </button>
                <span>{{url.totalRequests}} acessos</span>
              </div>
						</div>
					</v-expansion-panel-content>
				</v-expansion-panel>
			</v-expansion-panels>
<!-- 
      <v-sheet
        v-if="logs.length === 0"
        height="150"
        class="d-flex justify-center align-center rounded"
      >
        Nenhum registro encontrado!
      </v-sheet> -->
    <!-- modal -->
      <v-dialog
        transition="dialog-bottom-transition"
        max-width="800"
        v-model="drawer"
      >
        <EditSplitTest :testeAB="itemEdit[urlIndex]" @close="drawer = false"/>
      </v-dialog>

      <!-- Pagination -->
			<v-card class="mt-8 mb-8">
				<div
					v-if="!loading"
					class="list-footer">
					<span></span>
					<v-pagination
						v-model="page"
						:length="numberPages"
						color="#F0F1F3"
            :total-visible="7"
            @input="nextPage"
					></v-pagination>
					<div class="goToPage">
						<span class="goToPage--text">
							Ir para página
						</span>
						<label>
							<input
								v-model="goToPage"
								type="text"
							>
							<button
								@click="goToPageRequest"
								:disabled="disabledGoTo"
							>
								<div
									class="button-wrapper--text">
									<i class="iconStyle icon-arrow-right d-flex justify-center align-center"></i>
								</div>
							</button>
							<span
								:class="showGoToPageHelpText ? '--show-helptext' : '--hide-helptext'"
								class="goToPage--helptext"
							>
								A página deve estar entre 1 e {{numberPages}}
							</span>
						</label>
					</div>
				</div>
			</v-card>

      <div style="height: 0.1px"></div>
	</div>
</template>
<script>
import VueCookies from 'vue-cookies'

// Libs
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/pt-br'
import { mapActions, mapMutations, mapState } from 'vuex'
import moment from 'moment'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import VueClipboard from "vue-clipboard2";

// Components
import EditSplitTest from './EditSplitTest.vue'

//mixins
import date from '../../../mixins/date'

export default {
  mixins: [date],
  components: {
    DatePicker,
    EditSplitTest,
    ClipLoader,
    VueClipboard
  },
  async created () {
    await this.fecthLogs()
  },
  data () {
    return {
      loadingClear: false,
      loading: false,
      search_url: '',
      search_name: '',
      date: '',
      disabled: true,
      page: 1,
      goToPage: 1,
      disabledGoTo: false,
			showGoToPageHelpText: false,
      drawer: false,
      itemEdit: '',
      model: {
        testeAbName: "",
        testeAbShortUrl: "",
        createdAt: ""
      },
      urlIndex: '',
      toaster: {
        visible: false,
        color: '',
        message: '',
      },
    }
  },
  computed: {
    ...mapState('SplitTest',[
      'logs',
      'totalPages',
      'currentPage',
      'logsToEdit'
    ]),
    numberPages () {
      return this.totalPages
    },
    dateFormated () {
      return moment(this.date).format('DD/MM/YYYY')
    }
  },
  methods: {
    ...mapActions('SplitTest',[
      'splitABLogs',
      'splitABLogsFilter'
    ]),
    ...mapMutations('SplitTest', {
      setCurrentPage: 'SET_CURRENT_PAGE',
      setLogsToEdit: 'SET_LOGS_EDIT'
    }),
    async nextPage (e) {
      this.goToPage = this.page
      this.setCurrentPage(e - 1)
      await this.fecthLogs()
    },
    buildFilter () {
      let filter = ''
      const { search_url, date, search_name } = this
      if (search_url) filter += `&shortUrl=${this.search_url}`
      if (search_name) filter += `&testName=${this.search_name}`
      if (date) filter += `&date=${moment(this.date).format('YYYY-MM-DD')}`
      return filter
    },
    async fecthLogs () {
			const token = VueCookies.get('jwt-login')
      const size = 10
      const filter = this.buildFilter()
      try {
        this.loading = true
				await this.splitABLogsFilter({
          size,
          filter,
          token
        })
        this.loading = false
			}
			catch (error) {
				this.toaster(
          error.message,
          'var(--red)',
          true
        )
			}
    },
    clearForm () {
      this.search_url = '',
      this.search_name = '',
      this.date = ''
      this.setCurrentPage(0)
      this.goToPage = 1
      this.page = 1
      this.fecthLogs()
    },
    copy () {      
      this.$refs.clone.focus()
      document.execCommand('copy')
      this.copySucess()
    },
    copyLink(n) {
      this.$refs[n][0].value
      document.execCommand('copy')
			navigator.clipboard.writeText(this.$refs[n][0].innerHTML);
      this.copySucess()
    },
    copySucess () {
      this.toaster.visible = true,
      this.toaster.color = 'success',
      this.toaster.message = 'Url Copiada'
    },
    async goToPageRequest () {
      this.setCurrentPage(this.goToPage - 1);
      this.page = Number(this.goToPage)
      await this.filter();
    },
    setEditPush (index) {
      this.itemEdit = ''
      this.$emit('close', false)
      this.urlIndex = index
      this.itemEdit = this.logs
			this.drawer = !this.drawer
		},
  },
  watch: {
    'goToPage' () {
      if (this.goToPage < 1 || this.goToPage > this.numberPages) {
				this.showGoToPageHelpText = true
        this.disabledGoTo = true
      } else {
				this.showGoToPageHelpText = false
        this.disabledGoTo = false
      }
    },
    'search_url' () {
      this.search_url === '' ? this.disabled = true : this.disabled = false
    },
    'search_name' () {
      this.search_name === '' ? this.disabled = true : this.disabled = false
    },
    'date' () {
      this.date === '' ? this.disabled = true : this.disabled = false
    }
  }
}
</script>
<style lang="scss" scoped>
.theme--light.v-pagination .v-pagination__item--active {
	color: var(--black);
}
  .response-note {
    width: 1219px;

    .--h {
      height: 62px;
    }
  }

  .v-expansion-panel-header {
    height: 62px;
  }

  .v-expansion-panel-content {
    display: flex;
    justify-content: flex-start;
  }

  .borderLeft {
    height: 49px;
    max-width: 3px !important;
    width: 13px;
    background-color: var(--green);
    margin: 0 5px;
    position: absolute;
  }
  
  .v-expansion-panel--active .borderLeft {
    height: initial;
    // max-width: 3px !important;
    transition: 0.3s;
    width: 4px;
    background-color: var(--green);
    margin: 0px 5px;
    position: absolute;
    top: 9px;
    bottom: 9px;
  }

	.widthResponsive {
		width: 530px
	}

.b-4 {
	border: 2px solid var(--grey-day-030) !important;
	border-radius: 4px;
}

.b-red {
	border: 2px solid var(--red) !important;
	border-radius: 4px;
}

.h-48 {
  height: 48px
}

.responsiveField {
  width: 182px;
}

.urlresponsive {
  width: 670px;
}
.breakString {
  text-overflow: ellipsis;
  overflow: hidden;
}

// Pagination
.list-footer {
	background: var(--white);
	border-radius: 5px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0.75rem 2.625rem;
	margin: 80px 0;
	height: 64px;
}

.v-pagination__navigation, .v-pagination__item {
  border: none;
  box-shadow: none
}

.goToPage {
    &--text {
      font-size: 14px;
      font-family: var(--dm-sans-regular);
      color: var(--dark-grey);
      margin-right: 20px;
    }

    label {
      border: 2px solid var(--grey-day-030);
      background: var(--white);
      border-radius: 4px;
      box-sizing: border-box;
      max-width: 84px;
      width: 80px;
      padding: 10px;
      position: relative;

      input {
        width: 54px;
        font-size: 1rem;
        color: var(--grey);
        font-family: var(--dm-sans-regular);
      }

      button {
        position: absolute;
        border-radius: 50%;
        border: none;
        padding: 0;
        top: 11px;
        right: 8px;
        background: var(--grey);
        cursor: pointer;

        i {
          color: var(--white);
          font-size: 1.25rem;
        }
      }

      button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
      }
    }

    &--helptext {
      font-family: var(--dm-sans-regular);
      position: absolute;
      font-size: 12px;
      width: 120px;
      text-align: center;
      top: -55px;
      left: -24px;
      background: var(--dark-red);
      padding: 8px;
      color: var(--light-grey);
      border-radius: 4px;
    }

    .--hide-helptext {
      display: none;
    }

    .--show-helptext {
      display: block;
    }
  }

.mx-input-wrapper {
  width: 276px;
}

.responsiveFieldUrl {
  width: 334px;
}

@media screen and (max-width: 1377px) {
  .responsiveField {
    width: 158px;
  }

  .responsiveFieldUrl {
    width: 150px;
  }

  .urlresponsive {
    width: 110px;
  }

  .responsive-note {
		width: 817px
	}

  .vs__selected-options {
    width: 130px;
    padding-right: 20px;
  }

  .widthResponsive {
    margin-top: 10px;
    width: 113px
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Contents/SplitTest/LogsSplitTest.vue